import { memo, type ReactNode } from 'react';

import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import { SelectionActionBarPanel } from '~/components/v2/components/shared/selectionBar/SelectionActionBarPanel';
import { type SelectionActionBarItemCountState } from '~/components/v2/components/shared/selectionBar/selectionBarItemCountState';

export type BoardsAndAssetsSelectionBarProps = {
  itemCount: SelectionActionBarItemCountState;
  menuOptions: DropdownMenuOption[];
  prefixBarButtons?: ReactNode;
  suffixBarButtons?: ReactNode;
  stackLeftBarButtons?: boolean;
  hasSelection: boolean;
  onClearAll: () => void;
  selectAllLeftButtons?: ReactNode;
  summary: string;
};

export const BoardsAndAssetsSelectionBar = memo(
  ({
    itemCount,
    menuOptions,
    prefixBarButtons,
    suffixBarButtons,
    stackLeftBarButtons,
    hasSelection,
    onClearAll,
    selectAllLeftButtons,
    summary,
  }: BoardsAndAssetsSelectionBarProps) => {
    if (!hasSelection) {
      return null;
    }

    return (
      <SelectionActionBarPanel
        itemCount={itemCount}
        menuOptions={menuOptions}
        onClearAll={onClearAll}
        leftBarButtons={selectAllLeftButtons}
        stackLeftBarButtons={stackLeftBarButtons}
        prefixBarButtons={prefixBarButtons}
        suffixBarButtons={suffixBarButtons}
        summary={summary}
      />
    );
  },
);

BoardsAndAssetsSelectionBar.displayName = 'BoardsAndAssetsSelectionBar';
